import Sentry from '@shared/services/Sentry'

// Vuex plugin: mirror the authenticated staff user onto Sentry for the whole
// session, from the single shared store every portal module composes
// (`new Vuex.Store(storeConfig)`). It fires whenever `userProfile` changes —
// login (the `userProfile` mutation), boot hydrate (vuex-persistedstate
// rehydrates the allowlisted `userProfile`), and logout/reset (the reset
// mutation nulls `userProfile`) — independent of which component triggered it.
//
// This is the Vue 2 analog of the vue3 auth-store `setUser` and closes the gap
// where identity was only attached on-demand (the UserProfile mixin's API slow
// path + root Home.vue), leaving most error events/replays anonymous. Staff
// username is the email (firstname.lastname@holisticindustries.com), so fall
// back to it when no explicit email is present. Guarded so telemetry can never
// break the app.
export default function sentryUserPlugin(store) {
  let lastId
  const sync = (user) => {
    const id = user?.id ?? null
    if (id === lastId) return // only act when the identified user actually changes
    lastId = id
    try {
      Sentry.setUser(Sentry.toSentryUser(user))
    } catch (e) {
      console.warn('sentryUserPlugin: Sentry setUser failed', e)
    }
  }

  sync(store.state.userProfile) // seed from the hydrated (persisted) profile at boot
  store.subscribe((_mutation, state) => sync(state.userProfile))
}
